import "client-only"
import type { AppBridgeEvent } from "@/vendors/webview/bridge/app-bridge/AppBridgeEvent"

export function sendAppBridgeEvent(event: AppBridgeEvent): void {
  if (typeof window === "undefined" || !window.appbridge) {
    return
  }

  const payload = "data" in event ? event.data : undefined

  window.appbridge.invoke(event.action, payload).catch(() => {})
}

export async function sendAppBridgeEventAsync<Result>(
  event: AppBridgeEvent,
): Promise<Result | undefined> {
  if (typeof window === "undefined" || !window.appbridge) {
    return undefined
  }

  const payload = "data" in event ? event.data : undefined

  return window.appbridge.invoke<Result>(event.action, payload)
}
